export class TagsActions {
  static readonly SET_TAGS = '[TAGS] SET';
  static readonly ADD_TAG = '[TAGS] ADD';
};
